<donut-plans-onboarding-actions :plan-details="planDetails" :banner="banner"></donut-plans-onboarding-actions>